import { WebApiError } from '../services/http';

export const AI_ANALYSIS_POLL_INTERVAL_MS = 100;
export const AI_ANALYSIS_RUNNING_STALE_MS = 30_000;
export const AI_ANALYSIS_NO_RESULT_STALE_MS = 120_000;
export const AI_ANALYSIS_SLICE_RESTART_MS = 50;
export const AI_ANALYSIS_MAX_BOUNDED_RETRIES = 2;

const RETRYABLE_AI_ERROR_CODES = new Set([
  'PROCESSING_FAILED',
  'PROVIDER_TIMEOUT',
  'PROVIDER_UNAVAILABLE',
  'RESULT_INVALID',
  'SERVICE_UNAVAILABLE',
]);

export function isRetryableAiError(error: unknown): boolean {
  return error instanceof WebApiError && RETRYABLE_AI_ERROR_CODES.has(error.code);
}

export function aiRetryDelay(attempt: number): number {
  return Math.min(2_000, 250 * 2 ** Math.max(0, attempt - 1));
}

export function waitForAi(delay: number): Promise<void> {
  return new Promise((resolve) => globalThis.setTimeout(resolve, delay));
}
